const buildProxyUrl = (fileId, sizeHint = 'w1600-h1600') => {
  if (!fileId) return '';
  return `/api/image-proxy?id=${encodeURIComponent(fileId)}&sz=${encodeURIComponent(sizeHint)}`;
};

const extractDriveId = (raw) => {
  if (!raw || typeof raw !== 'string') return null;
  const rawTrim = raw.trim();
  if (rawTrim.startsWith('/api/image-proxy')) return null;
  const patterns = [
    /drive\.google\.com\/file\/d\/([a-zA-Z0-9_-]+)/,
    /[?&]id=([a-zA-Z0-9_-]+)/,
    /uc\?export=view&id=([a-zA-Z0-9_-]+)/,
    /thumbnail\?id=([a-zA-Z0-9_-]+)/,
    /lh3\.googleusercontent\.com\/d\/([a-zA-Z0-9_-]+)/,
    /^([a-zA-Z0-9_-]{25,})$/
  ];
  for (const p of patterns) {
    const m = rawTrim.match(p);
    if (m && m[1]) return m[1];
  }
  return null;
};

// Fonction pour convertir les URLs Google Drive en URLs publiques (via proxy backend)
export const getPublicImageUrl = (url) => {
  if (!url) return '';

  // Si c'est déjà une URL publique hors Google Drive, la retourner telle quelle
  if (url.includes('http') && !url.includes('drive.google.com') && !url.includes('googleusercontent.com')) {
    return url;
  }

  // Si c'est une URL Google Drive → utiliser le proxy backend
  const id = extractDriveId(url);
  if (id) {
    return buildProxyUrl(id, 'w1600-h1600');
  }

  return url;
};

// Fonction pour tester si une URL d'image est accessible
export const testImageUrl = async (url) => {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => resolve(true);
    img.onerror = () => resolve(false);
    img.src = getPublicImageUrl(url);
  });
};

// Image de fallback en base64
export const FALLBACK_IMAGE = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMIAAADDCAYAAADQvc6UAAABRWlDQ1BJQ0MgUHJvZmlsZQAAKJFjYGASSSwoyGFhYGDIzSspCnJ3UoiIjFJgf8LAwSDCIMogwMCcmFxc4BgQ4ANUwgCjUcG3awyMIPqyLsis7PPOq3QdDFcvjV3jOD1boQVTPQrgSkktTgbSf4A4LbmgqISBgTEFyFYuLykAsTuAbJEioKOA7DkgdjqEvQHEToKwj4DVhAQ5A9k3gGyB5IxEoBmML4BsnSQk8XQkNtReEOBxcfXxUQg1Mjc0dyHgXNJBSWpFCYh2zi+oLMpMzyhRcASGUqqCZ16yno6CkYGRAQMDKMwhqj/fAIcloxgHQqxAjIHBEugw5sUIsSQpBobtQPdLciLEVJYzMPBHMDBsayhILEqEO4DxG0txmrERhM29nYGBddr//5/DGRjYNRkY/l7////39v///y4Dmn+LgeHANwDrkl1AuO+pmgAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAwqADAAQAAAABAAAAwwAAAAD9b/HnAAAHlklEQVR4Ae3dP3Ik1RnG4W+FgYxN';
